import {rfidConstants} from "../constants/rfid.constants";

const initialState = {
    rfidDropdown: null,
    unusedList: null
}

export function rfidReducer(state = initialState, action) {
    switch (action.type) {
        case rfidConstants.REQUEST_DROPDOWN_LIST:
        case rfidConstants.FAILURE_DROPDOWN_LIST:
            return  {
                ...state,
                rfidDropdown: null
            }
        case rfidConstants.SUCCESS_DROPDOWN_LIST:
            return {
                ...state,
                rfidDropdown: action.dropdown
            }
        case rfidConstants.REQUEST_UNUSED_LIST:
            return {
                ...state,
                unusedList: null,
            }
        case rfidConstants.SUCCESS_UNUSED_LIST:
            return  {
                ...state,
                unusedList: action.unused
            }
        default:
            return state
    }
}